import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as profileActions from './store/profile/profileActions';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { SnackbarProvider } from 'notistack';
import Routes from './routes/Routes';
import { SnackbarUtilsConfigurator } from './utilities/snackbarUtils';
import { isRefreshTokenValid } from './utilities/auth';
import { useSnackbar } from 'notistack';
import './App.css';
import Button from '@mui/material/Button';
import getAppTheme from './theme/getAppTheme';
import { ThemeModeProvider, useThemeMode } from './theme/ThemeModeContext';

const styles = () => ({
    '@global': {
        body: {
            fontFamily: "'Saira', sans-serif;",
            paddingRight: '0 !important',
        },
    },
});
const DismissAction = (id) => {
    const { closeSnackbar } = useSnackbar();
    return (
        <Button color="inherit" onClick={() => closeSnackbar()}>
            <b>Close</b>
        </Button>
    );
};

const ThemedShell = ({ children }) => {
    const { mode } = useThemeMode();
    const theme = React.useMemo(() => getAppTheme(mode), [mode]);
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

class App extends React.Component {
    componentDidMount() {
        if (isRefreshTokenValid()) {
            this.props.profileActions.getProfile();
        }
    }

    render() {
        return (
            <ThemeModeProvider>
                <ThemedShell>
                    <SnackbarProvider
                        maxSnack={3}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        autoHideDuration={null}
                        action={(snackbarId) => (
                            <DismissAction id={snackbarId} />
                        )}
                    >
                        <SnackbarUtilsConfigurator />
                        <Routes />
                    </SnackbarProvider>
                </ThemedShell>
            </ThemeModeProvider>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        profileActions: bindActionCreators(profileActions, dispatch),
    };
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(App));
